(function () {
  'use strict';

  // The snippet is rendered once per advert, so this file can be
  // included several times on one page — run once.
  if (window.rsiMegaDealAdvertLoaded) return;
  window.rsiMegaDealAdvertLoaded = true;

  /* Keeps the mega-menu deal advert's "per bay" and "Save" figures in
     the same VAT mode as its main price, to the penny. Same mechanics as
     assets/rsi-pdp-bay-deals.js (verified against the deal pages' own
     prices): the advert is server-rendered inc VAT with pence in data
     attributes; the VAT & Tax Switcher app rewrites the advert's main
     price in place like any other price on the site (.finalPrice text =
     current mode, data-original-price = inc VAT); the divisor is learned
     from that pair — never a hard-coded rate — snapped to a 0.5% grid
     (k/200) and applied in integer maths, round-half-up, exactly as the
     app does. Per bay is rounded UP and the saving DOWN, so neither is
     ever flattering. If the price can't be read, the inc-VAT figures
     stay as rendered — correct by construction. */

  var FORMATTER = (typeof Intl !== 'undefined' && Intl.NumberFormat)
    ? new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' })
    : null;

  function money(pence) {
    var n = pence / 100;
    return FORMATTER ? FORMATTER.format(n) : ('£' + n.toFixed(2));
  }

  function parseMoney(text) {
    if (!text) return null;
    var m = String(text).replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }

  function init() {
    // One advert in the Shelving menu, two in Storage Boxes — each is
    // set up on its own and learns the VAT mode from its own price.
    Array.prototype.forEach.call(document.querySelectorAll('[data-rsi-mega-deal]'), setup);
  }

  function setup(root) {

    var dealInc = parseInt(root.getAttribute('data-rsi-md-deal-inc'), 10) || 0;
    var singleInc = parseInt(root.getAttribute('data-rsi-md-single-inc'), 10) || 0;
    // No single-unit product to compare with: the product's own
    // compare-at price (a real Admin value) is the reference instead.
    var refInc = parseInt(root.getAttribute('data-rsi-md-ref-inc'), 10) || 0;
    var bays = parseInt(root.getAttribute('data-rsi-md-bays'), 10) || 0;
    var perBay = root.querySelector('[data-rsi-md-perbay]');
    var save = root.querySelector('[data-rsi-md-save]');
    var label = root.querySelector('[data-rsi-md-vatlabel]');
    var lastK = null;

    /* 200 = inc VAT mode (divisor 1.000); 240 = ex VAT at 20%. */
    function currentK() {
      var el = root.querySelector('.rsi-mega-deal__price .finalPrice[data-original-price]');
      if (!el) return 200;
      var inc = parseMoney(el.getAttribute('data-original-price'));
      var shown = parseMoney(el.textContent);
      if (!(inc > 0) || !(shown > 0)) return 200;
      if (Math.abs(inc - shown) < 0.01) return 200;
      var k = Math.round((inc / shown) * 200);
      return (k > 200 && k < 400) ? k : 200;
    }

    function paint() {
      var k = currentK();
      if (k === lastK) return;
      lastK = k;
      var conv = function (pence) { return Math.round((pence * 200) / k); };

      if (perBay && dealInc > 0 && bays > 0) {
        perBay.textContent = money(Math.ceil(conv(dealInc) / bays));
      }

      if (save) {
        var pounds = 0;
        if (dealInc > 0 && bays > 0 && singleInc > 0) pounds = Math.floor((conv(singleInc) * bays - conv(dealInc)) / 100);
        else if (dealInc > 0 && refInc > dealInc) pounds = Math.floor((conv(refInc) - conv(dealInc)) / 100);
        if (pounds > 0) { save.textContent = 'Save £' + pounds; save.hidden = false; }
        else { save.hidden = true; }
      }

      if (label) label.textContent = (k > 200) ? 'ex VAT' : 'inc VAT';
    }

    paint();
    // Same cheap poll as the PDP ladder: the app mounts late and its
    // state can change from the header toggle at any time.
    window.setInterval(paint, 400);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.tax-switcher')) {
        window.setTimeout(paint, 60);
        window.setTimeout(paint, 300);
      }
    });

    // The image is lazy (the menu is closed on load, and phones never
    // show it). Start fetching it the moment the pointer or keyboard
    // reaches the desktop nav, so it is there before the menu opens.
    var img = root.querySelector('[data-rsi-md-img]');
    var nav = root.closest('nav') || root.closest('.rsi-header-nav') || document.querySelector('.rsi-header-nav__list');
    if (img && nav) {
      var warm = function () {
        img.loading = 'eager';
        nav.removeEventListener('pointerenter', warm);
        nav.removeEventListener('focusin', warm);
      };
      nav.addEventListener('pointerenter', warm);
      nav.addEventListener('focusin', warm);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
